import SalaryList from "./salaryList";
export default SalaryList